import 'react-native-get-random-values';
import { Platform } from 'react-native';

if (Platform.OS === 'web') {
  if (typeof window !== 'undefined' && !window.crypto) {
    window.crypto = {
      getRandomValues: function(buffer: Uint8Array) {
        for (let i = 0; i < buffer.length; i++) {
          buffer[i] = Math.floor(Math.random() * 256);
        }
        return buffer;
      }
    } as Crypto;
  }
}
